import styled from "@emotion/styled";
import { FC } from "react";
import { MDSBubbleSlotName } from "@/mds/components/bubble/bubble.types";
import { MDSLoadingArrows, MDSLoadingArrowsSize } from "@/mds/components/loading/loading-arrows";
import { useMDSSession } from "@/mds/components/sessions/session-context/mds-session-context";
import { SessionStatus } from "@/mds/components/sessions/session.types";

type Props = {
  isVisible?: boolean;
  slot?: MDSBubbleSlotName;
};

export const MDSBubbleSessionSenderIcon: FC<Props> = ({ slot, isVisible = true }) => {
  const { sessionStatus } = useMDSSession();
  const shouldLoop = sessionStatus === SessionStatus.Processing;

  if (!isVisible) {
    return <Placeholder />;
  }

  return (
    <StyledSenderIconContainer slot={slot}>
      <MDSLoadingArrows size={MDSLoadingArrowsSize.XSmall} loop={shouldLoop} />
    </StyledSenderIconContainer>
  );
};

/**
 * Using the negative margin to avoid taking up vertical space - this
 * enables subsequent messages to get closer to the first message in the group.
 */
const Placeholder = styled.div`
  margin-top: ${({ theme }) => theme.spacing["2"]};
  margin-bottom: -24px;
  margin-left: -2px;
  width: 24px;
  height: 24px;
`;

export const StyledSenderIconContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing["3"]};
  margin-bottom: -24px;
  margin-left: -3px;
  width: 24px;
  height: 24px;
  overflow: hidden;
`;
